import { SignIn, SignUp } from "@clerk/react";
import { Link } from "react-router-dom";

const Shell = ({ children }) => (
  <div className="min-h-screen grid lg:grid-cols-2 bg-mas-cream text-ink">
    <div className="hidden lg:flex relative bg-mas-ink">
      <img src="/images/spoken-word.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-60" />
      <div className="relative mt-auto p-12 text-mas-cream">
        <p className="eyebrow !text-mas-gold mb-3">MAS Arts Studio</p>
        <p className="font-serif text-4xl font-black leading-tight">Admin dashboard</p>
      </div>
    </div>
    <div className="flex flex-col items-center justify-center p-6 gap-6">
      <Link to="/" className="font-serif font-black text-2xl" data-testid="auth-back-home">MAS<span className="text-mas-terra">.</span></Link>
      {children}
    </div>
  </div>
);

export const SignInPage = () => (
  <Shell><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp fallbackRedirectUrl="/admin" /></Shell>
);

export const SignUpPage = () => (
  <Shell><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" fallbackRedirectUrl="/admin" /></Shell>
);
